module.exports = __webpack_public_path__ + "img/fart-clouds.8cf75f3f.png";